// EDIT ME: all membership content lives here. The Memberships section AND every
// skill "View Memberships" pop-up read from this single config - change once, updates everywhere.
export const MEMBERSHIPS = {
  section: {
    title: "Choose your membership",
    subtitle: "That Fits Your Learning Journey Best!",
    footerLine: "Your Music Journey. Your Choice. Let's make it extraordinary!",
    phone: "7738772358",
    location: "Sion East, Mumbai",
  },
  plans: [
    {
      name: "Bronze Membership",
      short: "Bronze",
      months: 1,
      tint: "bg-[#FAF1EA] border-[#E4C3A8]",
      price: "₹3,500",
      priceSuffix: "",
      valuePrice: null,
      savingsBadge: null,
      tag: null,
      perks: ["8 sessions per month", "Instrument provided"],
      highlighted: false,
      ctaLabel: "Book Your 2 Trial Sessions",
    },
    {
      name: "Silver Membership",
      short: "Silver",
      months: 3,
      tint: "bg-[#F4F5F7] border-[#C9CDD6]",
      badgeClass: "badge-silver",
      price: "₹6,500",
      priceSuffix: "Save ₹4,000",
      valuePrice: "₹10,500",
      savingsBadge: "38% OFF",
      tag: "BESTSELLER",
      perks: ["8 sessions per month", "Instrument provided", "Sprint 90-day practice booklet", "Personalized Student Feedback (PFS)", "TMH Unplugged live showcase"],
      highlighted: false,
      ctaLabel: "Book Your 2 Trial Sessions",
    },
    {
      name: "Gold Membership",
      short: "Gold",
      months: 6,
      tint: "bg-[#FCF6E0] border-[#E6D391]",
      badgeClass: "badge-gold",
      price: "₹9,500",
      priceSuffix: "Save ₹11,500",
      valuePrice: "₹21,000",
      savingsBadge: "55% OFF",
      tag: "MOST POPULAR",
      perks: ["8 sessions per month", "Instrument provided", "Sprint 90-day practice booklet", "Personalized Student Feedback (PFS)", "TMH Unplugged live showcase"],
      highlighted: true,
      ctaLabel: "Book Your 2 Trial Sessions",
    },
    {
      name: "Platinum Membership",
      short: "Platinum",
      months: 12,
      tint: "bg-[#EFF5F8] border-[#B9CDD9]",
      price: "₹16,500",
      priceSuffix: "Save ₹25,500",
      valuePrice: "₹42,000",
      savingsBadge: "61% OFF",
      tag: "BEST VALUE",
      perks: ["Everything in Gold"],
      highlighted: true,
      ctaLabel: "Book Your 2 Trial Sessions",
    },
  ],
};

export const planDurationLabel = (months) =>
  months === 12 ? "1 year" : `${months} month${months > 1 ? "s" : ""}`;
